import React from 'react';

const Row = ({ children, center, className }) => {
    return <div className={`row ${center ? 'justify-content-md-center' : ''} ${className ? className : ''}`}> {children}</div>;
};

export default Row;
